import tw from 'tailwind-styled-components'
import {Icon} from '@components/common/base/icon'
import {TagTheme} from '@components/common/base/tag/types'

export const TwTag = tw.div<{$theme?: TagTheme}>`
  cursor-pointer
  min-w-0
  [max-width:fit-content]
  py-2
  px-6
  rounded-4
  flex
  items-center
  justify-between
  gap-4
  ${p =>
    p.$theme === 'light'
      ? 'bg-grey-l80 hover:bg-interactive-l100'
      : 'bg-background-tooltip-informer'}
`

export const TwIcon = tw(Icon)`
  flex-none
`

export const TwText = tw.div<{$theme?: TagTheme}>`
  flex-initial
  text-12
  leading-4
  font-semibold
  ${p => (p.$theme === 'light' ? 'text-sticker-07' : 'text-icon-invert')}
  overflow-hidden
  whitespace-nowrap
  text-ellipsis
`
